export default "__VITE_ASSET__BmFWsadq__"